import {
  InMemoryHeader,
  InMemoryString,
  InMemoryBoolean,
  InMemoryDate,
  InMemoryInteger,
  InMemoryDecimal,
  HeaderAlignment,
} from "pbas-vue-components";
import { translate } from "../trans";
import store from "@/store";
import { translate2 } from "../trans2";
import { i18n } from "@/plugins/i18n";

const healthHeaders = [
  new InMemoryHeader({
    type: new InMemoryString("Id"),
    visible: false,
    isIdentifier: true,
    allowVisibilityChange: false,
  }),
  new InMemoryHeader({
    title: "components.claims_history.header.patient",
    type: new InMemoryString("Patient", {
      alignment: HeaderAlignment.Center
    }),
    sortable: true,
    visible: true,
    searchable: true,
    allowVisibilityChange: true,
  }),
  new InMemoryHeader({
    title: "components.new_claim.date_of_service",
    type: new InMemoryDate("DateOfService", {
      getString: (item, type) => {
        function parseValue(dateString) {
          if (dateString === undefined || dateString === null) {
            return "";
          }
          const [date, time] = dateString.split("T");
          const [year, month, day] = date.split("-");
          return `${year}-${month}-${day}`;
        }
        const parsed = parseValue(item.DateOfService);
        return parsed;
      },
      alignment: HeaderAlignment.Center
    }),
    sortable: true,
    visible: true,
    searchable: true,
    allowVisibilityChange: true,
  }),
  new InMemoryHeader({
    title: "globals.benefit",
    type: new InMemoryString("PlanBenefit", {
      alignment: HeaderAlignment.Center
    }),
    sortable: true,
    visible: true,
    searchable: true,
    allowVisibilityChange: true,
  }),
  new InMemoryHeader({
    title: "components.new_claim.expense",
    type: new InMemoryDecimal("ExpenseAmount", {
      alignment: HeaderAlignment.Center
    }),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new InMemoryHeader({
    title: "headers.benefits.cob",
    type: new InMemoryDecimal("COBAmount", {
      alignment: HeaderAlignment.Center
    }),
    sortable: true,
    visible: true,
    searchable: true,
  }),
];

const prescriptionHeaders = [
  new InMemoryHeader({
    type: new InMemoryString("Id"),
    visible: false,
    isIdentifier: true,
    allowVisibilityChange: false,
  }),
  new InMemoryHeader({
    title: "components.claims_history.header.patient",
    type: new InMemoryString("Patient", {
      alignment: HeaderAlignment.Center
    }),
    sortable: true,
    visible: true,
    searchable: true,
    allowVisibilityChange: true,
  }),
  new InMemoryHeader({
    title: "components.new_claim.date_of_service",
    type: new InMemoryDate("DateOfService", {
      getString: (item, type) => {
        function parseValue(dateString) {
          if (dateString === undefined || dateString === null) {
            return "";
          }
          const [date, time] = dateString.split("T");
          const [year, month, day] = date.split("-");
          return `${year}-${month}-${day}`;
        }
        const parsed = parseValue(item.DateOfService);
        return parsed;
      },
      alignment: HeaderAlignment.Center
    }),
    sortable: true,
    visible: true,
    searchable: true,
    allowVisibilityChange: true,
  }),
  new InMemoryHeader({
    title: "globals.benefit",
    type: new InMemoryString("PlanBenefit", {
      alignment: HeaderAlignment.Center
    }),
    sortable: true,
    visible: true,
    searchable: true,
    allowVisibilityChange: true,
  }),
  new InMemoryHeader({
    title: "headers.expense_info.din",
    type: new InMemoryString("DIN", {
      alignment: HeaderAlignment.Center
    }),
    sortable: true,
    visible: true,
    searchable: true,
    allowVisibilityChange: true,
  }),
  new InMemoryHeader({
    title: "components.claims_history.header.total_expense",
    type: new InMemoryDecimal("ExpenseAmount", {
      alignment: HeaderAlignment.Center
    }),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new InMemoryHeader({
    title: "components.new_claim.dispensing_fee",
    type: new InMemoryDecimal("LabFee", {
      alignment: HeaderAlignment.Center
    }),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new InMemoryHeader({
    title: "headers.benefits.cob",
    type: new InMemoryDecimal("COBAmount", {
      alignment: HeaderAlignment.Center
    }),
    sortable: true,
    visible: true,
    searchable: true,
  }),
];

const dentalHeaders = [
  new InMemoryHeader({
    type: new InMemoryString("Id"),
    visible: false,
    isIdentifier: true,
    allowVisibilityChange: false,
  }),
  new InMemoryHeader({
    title: "components.new_claim.date_of_service",
    type: new InMemoryDate("DateOfService", {
      getString: (item, type) => {
        function parseValue(dateString) {
          if (dateString === undefined || dateString === null) {
            return "";
          }
          const [date, time] = dateString.split("T");
          const [year, month, day] = date.split("-");
          return `${year}-${month}-${day}`;
        }
        const parsed = parseValue(item.DateOfService);
        return parsed;
      },
      alignment: HeaderAlignment.Center
    }),
    sortable: true,
    visible: true,
    searchable: true,
    allowVisibilityChange: true,
  }),
  new InMemoryHeader({
    title: "globals.benefit",
    type: new InMemoryString("PlanBenefit", {
      alignment: HeaderAlignment.Center
    }),
    sortable: true,
    visible: true,
    searchable: true,
    allowVisibilityChange: true,
  }),
  new InMemoryHeader({
    title: "components.new_claim.benefit_treatment_site",
    type: new InMemoryString(
      "BenefitTreatmentSite",
      {
        alignment: HeaderAlignment.Center
      } /*{
      getString: (item, type) => {
        if (item.BenefitTreatmentSite === null || item.BenefitTreatmentSite === undefined) {
          return "";
        }
        return `${item.BenefitTreatmentSite.Code} ${item.BenefitTreatmentSite.Name}`
      }
    }*/
    ),
    sortable: true,
    visible: true,
    searchable: true,
    allowVisibilityChange: true,
  }),
  new InMemoryHeader({
    title: "headers.expense_info.tooth",
    type: new InMemoryString("ToothCode", {
      getString: (item, type) => {
        if (item.ToothCode === null || item.ToothCode === undefined) {
          return "";
        }
        const lang = store.getters["common/language"];
        return `${item.ToothCode.Code} ${translate(
          item.ToothCode,
          lang.language
        )}`;
      },
      alignment: HeaderAlignment.Center
    }),
    sortable: true,
    visible: true,
    searchable: true,
    allowVisibilityChange: true,
  }),
  new InMemoryHeader({
    title: "headers.expense_info.surface",
    type: new InMemoryString("SurfaceCode", {
      alignment: HeaderAlignment.Center
    }),
    sortable: true,
    visible: true,
    searchable: true,
    allowVisibilityChange: true,
  }),
  new InMemoryHeader({
    title: "components.guides.dental_fee.title",
    type: new InMemoryDecimal("ExpenseAmount", {
      alignment: HeaderAlignment.Center
    }),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new InMemoryHeader({
    title: "headers.health_reasonable_customary_guides.lab_fee",
    type: new InMemoryDecimal("LabFee", {
      alignment: HeaderAlignment.Center
    }),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new InMemoryHeader({
    title: "headers.benefits.cob",
    type: new InMemoryDecimal("COBAmount", {
      alignment: HeaderAlignment.Center
    }),
    sortable: true,
    visible: true,
    searchable: true,
  }),
];
const hsaHeaders = [
  new InMemoryHeader({
    type: new InMemoryString("Id"),
    visible: false,
    isIdentifier: true,
    allowVisibilityChange: false,
  }),
  new InMemoryHeader({
    title: "components.claims_history.header.patient",
    type: new InMemoryString("Patient", {
      alignment: HeaderAlignment.Center
    }),
    sortable: true,
    visible: true,
    searchable: true,
    allowVisibilityChange: true,
  }),
  new InMemoryHeader({
    title: "components.new_claim.date_of_service",
    type: new InMemoryDate("DateOfService", {
      getString: (item, type) => {
        function parseValue(dateString) {
          if (dateString === undefined || dateString === null) {
            return "";
          }
          const [date, time] = dateString.split("T");
          const [year, month, day] = date.split("-");
          return `${year}-${month}-${day}`;
        }
        const parsed = parseValue(item.DateOfService);
        return parsed;
      },
      alignment: HeaderAlignment.Center
    }),
    sortable: true,
    visible: true,
    searchable: true,
    allowVisibilityChange: true,
  }),
  new InMemoryHeader({
    title: "globals.benefit",
    type: new InMemoryString("PlanBenefit", {
      alignment: HeaderAlignment.Center
    }),
    sortable: true,
    visible: true,
    searchable: true,
    allowVisibilityChange: true,
  }),
  new InMemoryHeader({
    title: "globals.category",
    type: new InMemoryString("CoveredBenefitCategory", {
      alignment: HeaderAlignment.Center
    }),
    sortable: true,
    visible: true,
    searchable: true,
    allowVisibilityChange: true,
  }),
  new InMemoryHeader({
    title: "components.new_claim.covered_benefit",
    type: new InMemoryString("CoveredBenefit", {
      alignment: HeaderAlignment.Center
    }),
    sortable: true,
    visible: true,
    searchable: true,
    allowVisibilityChange: true,
  }),
  new InMemoryHeader({
    title: "components.claims_history.header.total_expense",
    type: new InMemoryDecimal("ExpenseAmount", {
      alignment: HeaderAlignment.Center
    }),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new InMemoryHeader({
    title: "headers.benefits.cob",
    type: new InMemoryDecimal("COBAmount", {
      alignment: HeaderAlignment.Center
    }),
    sortable: true,
    visible: true,
    searchable: true,
  }),
];
const submittedHeaders = [
  new InMemoryHeader({
    title: "globals.status",
    type: new InMemoryString("State", {
      alignment: HeaderAlignment.Center
    }),
    sortable: true,
    visible: true,
    searchable: true,
    allowVisibilityChange: true,
  }),
  new InMemoryHeader({
    title: "components.claims_history.header.eligible_amount",
    type: new InMemoryDecimal("EligibleAmount", {
      alignment: HeaderAlignment.Center
    }),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new InMemoryHeader({
    title: "components.expenses_table.paid_amount",
    type: new InMemoryDecimal("PaidAmount", {
      alignment: HeaderAlignment.Center
    }),
    sortable: true,
    visible: true,
    searchable: true,
  }),
];
const actions = [new InMemoryHeader({
  title: "Actions",
  type: new InMemoryString("Actions", {
    alignment: HeaderAlignment.Center
  }),
  visible: true,
  allowVisibilityChange: false,
  searchable: false,
  sortable: false,
})];

const sickDayHeaders = [
  new InMemoryHeader({
    type: new InMemoryString("Id"),
    visible: false,
    isIdentifier: true,
    allowVisibilityChange: false,
  }),
  new InMemoryHeader({
    title: "components.claims_history.header.patient",
    type: new InMemoryString("Patient", {
      alignment: HeaderAlignment.Center
    }),
    sortable: true,
    visible: true,
    searchable: true,
    allowVisibilityChange: true,
  }),
  new InMemoryHeader({
    title: "components.new_claim.received_date",
    type: new InMemoryDate("ReceivedDate", {
      getString: (item, type) => {
        function parseValue(dateString) {
          if (dateString === undefined || dateString === null) {
            return "";
          }
          const [date, time] = dateString.split("T");
          const [year, month, day] = date.split("-");
          return `${year}-${month}-${day}`;
        }
        const parsed = parseValue(item.ReceivedDate);
        return parsed;
      },
      alignment: HeaderAlignment.Center
    }),
    sortable: true,
    visible: true,
    searchable: true,
    allowVisibilityChange: true,
  }),
  new InMemoryHeader({
    title: "components.new_claim.date_of_service",
    type: new InMemoryDate("DateOfService", {
      getString: (item, type) => {
        function parseValue(dateString) {
          if (dateString === undefined || dateString === null) {
            return "";
          }
          const [date, time] = dateString.split("T");
          const [year, month, day] = date.split("-");
          return `${year}-${month}-${day}`;
        }
        const parsed = parseValue(item.DateOfService);
        return parsed;
      },
      alignment: HeaderAlignment.Center
    }),
    sortable: true,
    visible: true,
    searchable: true,
    allowVisibilityChange: true,
  }),
  new InMemoryHeader({
    title: "globals.benefit",
    type: new InMemoryString("PlanBenefit", {
      alignment: HeaderAlignment.Center
    }),
    sortable: true,
    visible: true,
    searchable: true,
    allowVisibilityChange: true,
  }),
];
const sickHalfDayHeader = new InMemoryHeader({
  title: "components.claims_history.header.day_duration",
  type: new InMemoryString("DayDuration", {
    alignment: HeaderAlignment.Center
  }),
  sortable: true,
  visible: true,
  searchable: true,
  allowVisibilityChange: true,
});
function getClaimHeaders(coverageType, submitted, supportsHalfDays) {
  if (submitted) {
    if (coverageType === "Health") {
      return healthHeaders.concat(submittedHeaders).concat(actions);
    } else if (coverageType === "Prescription") {
      return prescriptionHeaders.concat(submittedHeaders).concat(actions);
    } else if (coverageType === "HSA") {
      return hsaHeaders.concat(submittedHeaders).concat(actions);
    } else if (coverageType === "SickDay") {
      if (supportsHalfDays) {
        return sickDayHeaders.concat([sickHalfDayHeader]).concat(submittedHeaders).concat(actions);
      } else {
        return sickDayHeaders.concat(submittedHeaders).concat(actions);
      }
    } else {
      return dentalHeaders.concat(submittedHeaders).concat(actions);
    }
  } else {
    if (coverageType === "Health") {
      return healthHeaders.concat(actions);
    } else if (coverageType === "Prescription") {
      return prescriptionHeaders.concat(actions);
    } else if (coverageType === "HSA") {
      return hsaHeaders.concat(actions);
    } else if (coverageType === "SickDay") {
      if (supportsHalfDays) {
        return sickDayHeaders.concat([sickHalfDayHeader]).concat(actions);
      } else {
        return sickDayHeaders.concat(actions);
      }
    } else {
      return dentalHeaders.concat(actions);
    }
  }
}
export default getClaimHeaders;
